@if (loaded()) {
<forge-card class="no-padding">
    <form #form="ngForm">
        <metadata-view [ngModelGroup]="view()!.Title" [viewTitle]="view()!.Title" [view]="view()!"
            [datacontroller]="datacontroller()">
        </metadata-view>
    </form>
</forge-card>
}